// extracted by mini-css-extract-plugin
module.exports = {"wrap":"main_wrap__F79-c"};